import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'dayFinder',
    standalone: false
})
export class DayFinderPipe implements PipeTransform {

  transform(value: any, type: string): unknown {
    if (value) {
      const date = new Date(value);
      return handleTheResult(type, date)
    }
    return '-';
  }

}

/**
 * Gets the day 
 * date.getDay() it return's ==> 0,1,2...6
 * return based on the above return to pass the index to weekDays
 * @param date 
 * @returns  
 */
function getTheday(date: any) {
  return weekDays[date.getDay()]
}

function handleTheResult(type: string, value: any) {
  switch (type) {
    case "find_day":
      return getTheday(value)
      break;
    default:
      return '-'
      break;
  }
}

const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
